import React from "react";

// Arkision brand mark — angular "A" built from the brand's triangular identity
const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5 select-none">
    <svg width="34" height="34" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path d="M20 4L36 34H28.5L20 17.5L11.5 34H4L20 4Z" fill="#22d3ee" />
      <path d="M20 22L25 32H15L20 22Z" fill="#04060a" />
      <circle cx="20" cy="34" r="2.4" fill="#38bdf8" />
    </svg>
    {!compact && (
      <div className="leading-none">
        <span className="font-display text-lg font-bold tracking-wide text-white">
          ARKISION <span className="text-cyan-400">AI</span>
        </span>
        <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.22em] text-slate-500">
          Smarter Conversations. Better Care.
        </span>
      </div>
    )}
  </div>
);

export default Logo;
